
import React from 'react'
import { BasePage as CngBasePage } from 'cng-web-lib'
import { ScopedCssBaseline } from '@mui/material';
import useBreadcrumbNameMap from 'src/useBreadcrumbNameMap';
import ABIEntrySummaryTranslationProvider from './contexts/ABIEntrySummaryTranslationContext';
import UserSettings from './component/UserSettings';

// const fullTitle = 'ABI User Settings';
// const shortTitle = 'Settings';
// const BCrumb = [
//   { title: "ABI" },
//   { title: "Entry Summary", to: pathMap.ABI_ENTRY_SUMMARY_LIST_VIEW },
//   { title: shortTitle, },
// ];


function SettingsPage(props) {
  const breadcrumbNameMap = useBreadcrumbNameMap()
  return (
    <CngBasePage
      renderPage={(showSnackbar) => (
        <ABIEntrySummaryTranslationProvider>
          <ScopedCssBaseline>
            <UserSettings showNotification={showSnackbar} {...props} />
          </ScopedCssBaseline>
        </ABIEntrySummaryTranslationProvider>
      )}
      extraCngBreadcrumbNameMap={breadcrumbNameMap}
    />
  );
}
export default SettingsPage
